/* Clara & Luce — "Visti di recente": lista en localStorage + fichas desde /products/<handle>.js */
(function () {
  'use strict';
  var KEY = 'cl_recent';
  var box = document.querySelector('.cl-recent[data-current]');
  if (!box) return;
  var current = box.getAttribute('data-current');
  var max = parseInt(box.getAttribute('data-max'), 10) || 8;

  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];

  var others = list.filter(function (h) { return h && h !== current; }).slice(0, max);
  try {
    localStorage.setItem(KEY, JSON.stringify([current].concat(others).slice(0, 16)));
  } catch (e) {}
  if (!others.length) return;

  var money = function (cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  var img = function (src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  Promise.all(others.map(function (h) {
    return fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (items) {
    var html = '';
    var valid = [];
    items.forEach(function (p, i) {
      if (!p || !p.available) return;
      valid.push(others[i]);
      var sale = p.compare_at_price && p.compare_at_price > p.price;
      html += '<a class="cl-recent__card" href="' + p.url + '">' +
        '<span class="cl-recent__img">' + (p.featured_image ? '<img src="' + img(p.featured_image, 360) + '" alt="' + esc(p.title) + '" loading="lazy" width="180" height="240">' : '') +
        (sale ? '<span class="cl-recent__badge">-' + Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) + '%</span>' : '') + '</span>' +
        '<span class="cl-recent__name">' + esc(p.title.split(' | ')[0]) + '</span>' +
        '<span class="cl-recent__price">' + (sale ? '<s>' + money(p.compare_at_price) + '</s> ' : '') + '<span' + (sale ? ' class="is-sale"' : '') + '>' + money(p.price) + '</span></span>' +
        '</a>';
    });
    // limpia de la memoria los productos que ya no existen o están agotados
    try { localStorage.setItem(KEY, JSON.stringify([current].concat(valid).slice(0, 16))); } catch (e) {}
    if (!html) return;
    box.querySelector('.cl-recent__list').innerHTML = html;
    box.hidden = false;
  });
})();
